import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
  Stack,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Grid
} from '@mui/material';
import LandingForthImg from '../../assests/images/LandingForthImg.svg';
import LandingSecondImg from '../../assests/images/LandingSecondImg.svg';
import LandingFirstImg from '../../assests/images/LandingFirstImg.svg';
import LandingCenterImg from '../../assests/images/TPOLogo.svg';
import DegreedPathwayImg from '../../assests/images/DegreedPathway.svg';
import { useOkta } from '../../hooks/oktaHook';
import { getUrlWithParams } from '../../utils/Utils';

const cardsList = [
  {
    id: 'PO Intro Video',
    cardHeader: 'PO Intro Video',
    cardContent: 'Discover PO features and insights powered by advanced algorithm.',
    cardButton: 'Watch Video',
    cardImage: LandingFirstImg,
    cardText: 'customer view',
    cardLink:
      // eslint-disable-next-line max-len
      'https://pepsico.sharepoint.com/:v:/t/TPO-Gen3/EZvdJGcx6YdLtLJNyDTaXEsBIEs6Ibnth9O2C0IPQin5Og?e=PJU6II', //link changed
    cardType: 'sides'
  },
  {
    id: 'PO Playbook',
    cardHeader: 'PO Playbook',
    cardContent: 'A range of materials to initiate, deploy or enhance current PO processes.',
    cardButton: 'Access',
    cardImage: LandingSecondImg,
    cardText: 'customer view',
    cardLink: 'https://rise.articulate.com/share/WGlKsy2EKZjAi0A5QRDy-PsqHPIZXab_#/',
    cardType: 'sides'
  },
  {
    id: 'PO Sharepoint',
    cardHeader: 'PO Sharepoint',
    cardContent: 'Access additional support materials and tutorial videos for PO features.',
    cardButton: 'Explore',
    cardImage: LandingForthImg,
    cardText: 'customer view',
    cardLink: 'https://pepsico.sharepoint.com/sites/GO-TPO',
    cardType: 'sides'
  },

  {
    id: 'Help Us Enhance PO',
    cardHeader: 'Help Us Enhance PO',
    cardContent: 'A range of materials to initiate, deploy or enhance current PO processes.',
    cardButton: 'Feedback',
    cardImage: LandingSecondImg,
    cardText: 'customer view',
    cardLink:
      'https://forms.office.com/pages/responsepage.aspx?id=lTLMQg7NnES5jlzltWDB0xjkzUW41rdEktutp7HBIWFUMkFFQVZHNlc3SE5GMFJOQTU0TzZSRzlTNyQlQCN0PWcu&route=shorturl',
    cardType: 'sides'
  },
  {
    id: 'PEP U (PEPU) Degreed',
    cardHeader: 'PEP U (PEPU) Degreed',
    cardContent: 'Learning pathway to deepen PO expertise and guide strategic portfolio decisions.',
    cardButton: 'Learn',
    cardImage: DegreedPathwayImg,
    cardText: 'customer view',
    cardLink:
      'https://degreed.com/pathway/w9dey5e2pj?orgsso=pepsico',
    cardType: 'sides'
   }
];

const LandingPageComponents = ({ loginBtnDisabled }) => {
  const { authState, oktaAuth } = useOkta();
  const currentPath = window.location.pathname;

  useEffect(() => {
    if (authState?.isAuthenticated && currentPath === '/logout') {
      oktaAuth.signOut();
    }
  }, [currentPath, authState]);

  return (
    <>
      <Grid container spacing={0.2}>
        <Grid item xs={12} sx={{ height: '270px' }}>
          <Stack
            gap={2}
            sx={{
              m: '24px',
              p: 2,
              backgroundColor: '#FBFCFE',
              height: '100%'
            }}>
            <EnterTPOComponent loginBtnDisabled={loginBtnDisabled} />
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <CardsComponent />
        </Grid>
      </Grid>
    </>
  );
};

const EnterTPOComponent = ({ loginBtnDisabled }) => {
  const card = {
    cardContent2: 'Welcome to Portfolio Optimization Tool. ',
    cardContent3: 'Please click below to access PO Gen2 main features',
    cardButton: 'Enter PO',
    cardImage: LandingCenterImg,
    cardText: 'customer view',
    cardType: 'center'
  };
  const navigate = useNavigate();

  const { search } = useLocation();

  const newParams = new URLSearchParams(search);
  const bu = newParams.get('bu');

  const onClick = () => {
    navigate(getUrlWithParams('/home', bu));
  };
  return (
    <Grid container spacing={2} sx={{ padding: '0rem 5rem' }}>
      <Grid item xs={12} sm={6}>
        <Stack direction="row" sx={{ justifyContent: 'center', alignItems: 'flex-end' }}>
          <img style={{ width: '500px', height: '270px' }} src={card.cardImage} alt="img" />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Stack
          direction="column"
          sx={{ height: '100%', justifyContent: 'center', alignItems: 'flex-end' }}
          spacing={3}>
          <Typography variant="h6" fontWeight="500">
            {card.cardContent2}
            <br />
            {card.cardContent3}
          </Typography>
          {!loginBtnDisabled && (
            <Button
              sx={{ borderRadius: '40px', width: '160px', height: '40px' }}
              size="large"
              variant="contained"
              color="primary"
              endIcon={<ArrowForwardIcon />}
              onClick={() => onClick()}>
              Enter PO
            </Button>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

const CardsComponent = () => {
  return (
    <Grid container spacing={2} sx={{ padding: '0px 24px', marginTop: '24px' }}>
      {cardsList.map((card, i) => (
        <Grid item xs={12/5} key={`${i + 1}`}>
          <CardDetails cardsData={card} />
        </Grid>
      ))}
    </Grid>
  );
};

const CardDetails = ({ cardsData }) => {
  return (
    <Card
      sx={{
        borderRadius: '8px',
        backgroundColor: '#FBFCFE',
        boxShadow: '0px 0px 24px rgba(0, 92, 188, 0.08)'
      }}>
      <Grid container sx={{ padding: '16px' }} spacing={2}>
        <Grid item>
          <CardMedia
            sx={{ width: '20px', height: '20px' }}
            image={cardsData.cardImage}
            title={cardsData.cardText}
          />
        </Grid>
        <Grid item xs sx={{ marginTop: '-3px' }}>
          <Typography gutterBottom variant="h6" component="div" fontWeight="700">
            {cardsData.cardHeader}
          </Typography>
        </Grid>
      </Grid>
      <CardContent>
        <Typography variant="body2" fontWeight="400">
          {cardsData.cardContent}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button
          sx={{
            borderRadius: '40px',
            color: '#005CBC',
            padding: '7px 15px',
            borderColor: '#005CBC',
            height: '28px'
          }}
          size="small"
          variant="outlined"
          color="secondary"
          target="_blank"
          endIcon={<ArrowForwardIcon />}
          href={cardsData.cardLink}>
          {cardsData.cardButton}
        </Button>
      </CardActions>
    </Card>
  );
};

const LandingPage = ({ loginBtnDisabled }) => {
  return (
    <div
      style={{
        backgroundColor: '#F3F7FD',
        width: '100%',
        height: 'calc(100% - 50px)',
        overflow: 'hidden'
      }}>
      <LandingPageComponents loginBtnDisabled={loginBtnDisabled} />
    </div>
  );
};

export default LandingPage;
